import { ReactNode, useContext } from "react";
import { SiteResolutionContext, decodeSiteResolutionFunc } from 'shared/mechanics/site-resolution';

import { PageContainerDesktopComponent, PageContainerCompactComponent } from './PageContainer';
import { SettingsContainerTitleProps } from "./SettingsContainer";

export interface PageWithSettingsProps {
	settingsTitleChild: (props: SettingsContainerTitleProps) => ReactNode;
	settingCompactModeShowButtonText: string;

	settingsContentChild: ReactNode;
	settingsActionsChild?: ReactNode;
	contentChild: ReactNode;
	defaultIsSettingsExpanded: boolean;
}

export const PageWithSettingsComponent = (props: PageWithSettingsProps) => {
	const siteResolution = useContext(SiteResolutionContext);

	const pageContainerComponent = decodeSiteResolutionFunc(
		siteResolution,
		() => <PageContainerDesktopComponent {...props} />,
		() => <PageContainerCompactComponent {...props} />);

	return pageContainerComponent;
}
